import { ProjectTableModalType } from './types';
import { tableColumns } from '../ProjectTable/constants';

export const modalConfigs = {
  selectLessons: ({
    category,
    pillarType,
    pillarExpertise,
  }: {
    category?: string;
    pillarType?: string;
    pillarExpertise?: string;
  }) => ({
    type: 'selectLessons' as ProjectTableModalType,
    tableConfig: tableColumns.lessonsPreview,
    searchLabel: 'Search lesson',
    category,
    pillarType,
    pillarExpertise,
  }),
  showMoreCalendarLessons: () => ({
    type: 'showMoreCalendarLessons' as ProjectTableModalType,
    tableConfig: tableColumns.lessonsPreview,
  }),
  selectCollections: ({
    category,
    pillarType,
    pillarExpertise,
  }: {
    category?: string;
    pillarType?: string;
    pillarExpertise?: string;
  }) => ({
    type: 'selectCollections' as ProjectTableModalType,
    tableConfig: tableColumns.collectionsPreview,
    searchLabel: 'Search collection',
    category,
    pillarType,
    pillarExpertise,
  }),
  selectBundles: ({
    category,
    pillarType,
    pillarExpertise,
  }: {
    category?: string;
    pillarType?: string;
    pillarExpertise?: string;
  }) => ({
    type: 'selectBundles' as ProjectTableModalType,
    tableConfig: tableColumns.bundlesPreview,
    searchLabel: 'Search bundle',
    category,
    pillarType,
    pillarExpertise,
  }),
  selectGoals: {
    type: 'selectGoals' as ProjectTableModalType,
    tableConfig: tableColumns.goalsPreview,
    searchLabel: 'Search goal',
  },
};
